import completion from "./completion.jpg";
import styles from "./Completion.module.scss";
export default function Completion() {

    return (
        <>
         <img className={styles.myImage} src={completion} alt="logo"  />
        </>
    )
}